var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#054A59",
    fillRule: "evenodd",
    d: "M22.783 1.72a.75.75 0 0 1 .17.8l-7.5 19.5a.75.75 0 0 1-1.384.041l-3.136-6.9 4.614-4.615a1.125 1.125 0 0 0-1.59-1.59L9.34 13.57l-6.9-3.136a.75.75 0 0 1 .042-1.384l19.5-7.5a.75.75 0 0 1 .8.17",
    clipRule: "evenodd"
  })));
};
export default SvgMail;